import React from 'react';
import {enConfig} from './Lang/en';
import {arConfig} from './Lang/ar';
import {frConfig} from './Lang/fr';
import {esConfig} from './Lang/es';
import {cnConfig} from './Lang/cn';

const translations = {
  ar: arConfig,
  en: enConfig,
  fr: frConfig,
  es: esConfig,
  cn: cnConfig
}

const LangSwitcher = ({lang, onLang}) => {
  //const { lang, setLang } = useContext(LangContext);

  const onChange = (event) => {
    let lg = event.target.value
    onLang(lg);
    //alert(lg)
  };

  const onMouseLeave = (event) => {
    //alert('mouse leave')
    event.currentTarget.blur();
  };

  return (
    
    <select onChange={onChange} onMouseLeave={e => e.currentTarget.blur()} id="SwitchLang" className="Switcher" value={lang}>
      <option alt="Arabic" value="ar">العربية</option>
      <option alt="English" value="en">English</option>    
      <option alt="Frensh" value="fr">Français</option>
      <option alt="Spanish" value="es">Español</option>
      <option alt="Chinese" value="cn">汉语</option>
    </select>
    
  );
};


const Ts = (lang,key,item=null) => {
  //const { lang, setLang } = useContext(LangContext)
  //alert(lang)
  if(item===null) 
    return translations[lang][key] || key;
  else
    return translations[lang][key][item] || key+"-"+item
};

export {LangSwitcher, Ts}

/*
  <option alt="Frensh" value="fr">Français</option>
  <option alt="Spanish" value="es">Español</option>
  <option alt="Chinese" value="cn">汉语</option>
*/